/**
 * 銷貨單 SN 選用（sn-candidates／sn-selections）共用小工具。
 */

/** sn-candidates `lines[].mtrs[]` → `{ [salesOrderLineMtrId]: mtrSnId[] }`。 */
export function buildSalesOrderSnSelectionMap(snLines) {
  const map = {};
  (snLines ?? []).forEach((line) => {
    (line?.mtrs ?? []).forEach((mtr) => {
      map[String(mtr.salesOrderLineMtrId)] = (mtr.selectedMtrSnIds ?? []).map(String);
    });
  });
  return map;
}

export function isSalesOrderSnMtrComplete(mtr, selectedIds) {
  return (selectedIds?.length ?? 0) === Number(mtr?.requiredQty ?? 0);
}

/** PUT body 用：完整替換，每個 line mtr 一筆。 */
export function buildSalesOrderSnSelectionsPayload(snLines, selectionMap, { updatedAt }) {
  return {
    updatedAt,
    selections: (snLines ?? []).flatMap((line) => (line?.mtrs ?? []).map((mtr) => ({
      salesOrderLineMtrId: mtr.salesOrderLineMtrId,
      mtrSnIds: selectionMap[String(mtr.salesOrderLineMtrId)] ?? [],
    }))),
  };
}
